import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';

import { CancelSubscriptionReasons, SubscriptionPlan } from '@vi-iot/client';

import { BookingStore, CANCELING_STATUS } from '@store';

@Component({
  selector: 'app-cancel-booking-modal',
  templateUrl: './cancel-booking-modal.component.html',
  styleUrls: ['./cancel-booking-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelBookingModalComponent {
  readonly status = CANCELING_STATUS;
  readonly subscriptionsPlanType = SubscriptionPlan;
  readonly minlengthOfComment = 1;
  readonly maxlengthOfComment = 130;

  cancelSubscriptionReasons: CancelSubscriptionReasons[] = [
    {
      reasonKey: '11',
      name: '+BOOKING.CANCEL_BOOKING_MODAL.REASON.PERFORMANCE',
      additionalCommentsMandatory: false,
    },
    {
      reasonKey: '14',
      name: '+BOOKING.CANCEL_BOOKING_MODAL.REASON.MISSING_FEATURES',
      additionalCommentsMandatory: true,
    },
    {
      reasonKey: '15',
      name: '+BOOKING.CANCEL_BOOKING_MODAL.REASON.NO_ADDED_VALUE',
      additionalCommentsMandatory: true,
    },
    {
      reasonKey: '16',
      name: '+BOOKING.CANCEL_BOOKING_MODAL.REASON.NOT_SURE_HOW_TO_USE',
      additionalCommentsMandatory: false,
    },
    {
      reasonKey: '17',
      name: '+BOOKING.CANCEL_BOOKING_MODAL.REASON.CANCELLED_CONTRACT',
      additionalCommentsMandatory: false,
    },
    {
      reasonKey: '18',
      name: '+BOOKING.CANCEL_BOOKING_MODAL.REASON.NOT_MEET_EXPECTATION',
      additionalCommentsMandatory: false,
    },
    {
      reasonKey: '19',
      name: '+BOOKING.CANCEL_BOOKING_MODAL.REASON.OTHER',
      additionalCommentsMandatory: true,
    },
  ];
  selectedReason: CancelSubscriptionReasons;
  additionalComment = '';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      boilerId: string;
      companyId: string;
      isFlatRate: boolean;
      subscriptionPlan: SubscriptionPlan;
    },
    public dialogRef: MatDialogRef<CancelBookingModalComponent>,
    public bookingStore: BookingStore
  ) {}

  isDisabledWhenMandatoryCommentEmpty(): boolean {
    if (this.selectedReason) {
      return this.selectedReason.additionalCommentsMandatory
        ? this.additionalComment.length <= 0
        : false;
    } else return true;
  }

  onCancelBooking(): void {
    if (this.data?.isFlatRate) {
      this.bookingStore.flatRateCancelSubscription(
        this.selectedReason.reasonKey,
        this.additionalComment,
        this.data.companyId
      );
    } else {
      this.bookingStore.cancelVitoguideSubscription(
        this.selectedReason.reasonKey,
        this.data.boilerId,
        this.additionalComment,
        this.data.companyId
      );
    }
  }

  onClose(): void {
    this.dialogRef.close();
    this.bookingStore.resetCancelSubscriptionStatus();
    this.selectedReason = null;
  }

  onTryAgain(): void {
    this.bookingStore.resetCancelSubscriptionStatus();
    this.selectedReason = null;
  }

  onReasonSelect(event: MatRadioChange): void {
    this.selectedReason = event.value;
  }
}
